import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import {
  FilterModel,
  FilterModels,
  ListingFiltersSource
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { MISSING_PROGRAMMING_RECORDS_DATE_TIME } from './missing-programming-records-listing.filters';

@Injectable()
export class MissingProgrammingRecordsListingFiltersSourceService implements ListingFiltersSource {
  getAll(): Observable<FilterModels> {
    return of([MISSING_PROGRAMMING_RECORDS_DATE_TIME]);
  }

  getReportGroup(): Observable<FilterModel> {
    return of();
  }
}
